import React from "react";

export default function CategoryBar({
    categories,
    activeId,
    onSelect,
    testIdPrefix = "cat",
}) {
    if (!categories || categories.length === 0) return null;
    const items = [{ id: null, name: "All" }, ...categories];
    return (
        <nav data-testid="category-bar" className="px-4 py-2">
            <ul className="flex flex-wrap justify-center gap-2">
                {items.map((c) => {
                    const isActive = (c.id || null) === (activeId || null);
                    return (
                        <li key={c.id || "all"}>
                            <button
                                data-testid={`${testIdPrefix}-${c.id || "all"}`}
                                type="button"
                                onClick={() => onSelect?.(c.id || null)}
                                className={
                                    "px-4 py-1.5 rounded-full border text-xs uppercase tracking-[0.2em] whitespace-nowrap transition-colors " +
                                    (isActive
                                        ? "kw-orange-bg border-[#FF5A00] text-black font-bold"
                                        : "border-white/15 text-white/60 hover:text-white hover:border-white/40")
                                }
                            >
                                {c.name}
                            </button>
                        </li>
                    );
                })}
            </ul>
        </nav>
    );
}
